<template>
  <div class="holler">
    <div class="holler-hero">
        <!-- <img class="holler-hero-picture" src="../assets/holler/holler-cover-lodef.jpg" /> -->
        <div class="holler-hero-info">
            <img class="holler-hero-info-cover" src="../assets/holler/HOLLER_ARTWORK_HD.jpg" />
            <img class="holler-hero-info-logo" src="../assets/LOGO_TAUR-WHITE-TRANSPARENT.png" />
            <p class="holler-hero-info-text">
                New single "Holler" <br />
                29.01.2021
            </p>
            <Player isHoller isSmall class="holler-hero-info-player" />
            <div class="holler-hero-info-logos">
                <img src="../assets/poprecords-transparent.png" />
                <img src="../assets/polydor.png" />
                <img src="../assets/gum-white.jpg" />
            </div>
        </div>

        <video class="holler-hero-video" src="../assets/holler/holler-background-mp4.mp4" autoplay="autoplay" muted loop />
        
        
    </div>
    
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Player from '../components/Player.vue'


export default defineComponent({
    name: 'Holler',
    components: {
        Player,
    },
    beforeCreate() {
        const password = prompt('Please enter the password to continue')
        if (password !== 'TAUR2021') {
            return this.$router.push('/')
        }
    }
})
</script>

<style lang="scss">
.holler {
  position: relative;
  text-align: left;
  overflow: hidden;

  &-hero {
        width: 100vw;
        height: 100vh;
        background: black;

        // &-picture {
        //     left: 50%;
        //     transform: translateX(-50%);
        //     height: 100vh;
        //     position: absolute;
        // }

        &-video {
            position: absolute;
            left: 0;
            right: 0;
            height: 100vh;
            width: 100vw;
            object-fit: cover;
            z-index: 1;
            -webkit-filter: blur(8px);
            -moz-filter: blur(8px);
            -o-filter: blur(8px);
            -ms-filter: blur(8px);
            filter: blur(8px);
        }

        &-info {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 2;
            text-align: center;

            &-cover {
                display: block;
                margin: 0 auto 20px;
                width: 40vh;
                box-shadow: 0 0px 30px rgba(0, 0, 0, 0.5);
            }

            &-logo {
                width: 15%;
            }

            &-text {
                position: relative;
                top: 0px;
                margin-bottom: 0px;
                color: white;
                font-size: 14px;
            }

            &-player {
                transform: scale(0.7);
                margin: 0 auto;
            }

            &-logos {
                transform: scale(0.8);
                img {
                    margin-right: 10px;
                }
            }

        }

        // &-logo {
        //     position: absolute;
        //     top: 65%;
        //     transform: translate(-50%, -65%);
        //     left: 50%;
        //     width: 10%;
        //     z-index: 2;
        // }

        // &::after {
        //     content: '';
        //     display: block;
        //     position: absolute;
        //     z-index: 100;
        //     height: 100%;
        //     width: 30vw;
        //     background: linear-gradient(90deg, rgb(250, 250, 252) 50%, rgba(255,255,255,0) 100%);
        //     left: 0;
        //     top: 0;
        //     bottom: 0;
        //     z-index: 1;
        // }

        // &::before {
        //     content: '';
        //     display: block;
        //     position: absolute;
        //     z-index: 100;
        //     height: 100%;
        //     width: 30vw;
        //     background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgb(250, 250, 252) 50%,);
        //     right: 0;
        //     bottom: 0;
        //     z-index: 1;
        // }
  }
}
</style>
